import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import InsightsRequestModal from 'modules/shift_management/components/ShiftManagement/InsightsRequestModal'
import { usePermissions } from 'modules/shift_management/hooks/usePermissions'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

const InsightsRequestComponent = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [{ view }] = useSchedule()
  const [{ canAccessTimeInsights, canSeeTimeInsightsForEverybody }] = usePermissions()

  if (!canAccessTimeInsights) return null

  return (
    <ResponsivePage.Body>
      <InsightsRequestModal
        canSeeInsightsForEverybody={canSeeTimeInsightsForEverybody}
        onClose={() =>
          navigate(
            navigation.shifts.customViewGroup.fullPath({
              viewType: view.viewType,
              groupType: view.groupType,
              year: view.startRangeYear,
              month: view.startRangeMonth,
              day: view.startRangeDay,
            })
          )
        }
      />
    </ResponsivePage.Body>
  )
}

const InsightsRequest = observer(InsightsRequestComponent)

export default InsightsRequest
